import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Skeleton, Spin } from "antd";
import { useRouter } from "../util/router";
import { useUser } from "../util/user";
import { useSite } from "../util/sites";

import NotFoundPage from "../components/general/NotFound";
import BESSDashboard from "../components/bess/BESSDashboard";

function BESSPage() {
  const router = useRouter();
  const [hasAccess, setHasAccess] = React.useState(false);
  const userObj = useUser();
  const selectedSite = useSite()?.selectedSite?.value;

  useEffect(() => {
    // User is authenticated
    if (userObj?.roles?.includes("dashboard:_view")) {
      // User has access to this page
      if (selectedSite?.is_BESS) {
        setHasAccess(true);
      }
    } else {
      router.push("/solar/logout");
    }

  }, [userObj, router, selectedSite]);

  return (
    <>
      {hasAccess ? (
        <BESSDashboard />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
}

export default BESSPage;